const TroubleShooting = () => import("Modules/troubleshooting/views/TroubleShooting");

export default {
    children: [
        {
            path: "techhelp",
            name: "techhelp",
            component: TroubleShooting,
            meta: {
                requiresAuth: true,
                title: "lang.techhelp",
                restrict_by_login_type: [
                    "employee",
                    "customer_support",
                    "administrator",
                    "developer",
                    "csr",
                    "producer",
                    "dispatcher",
                    "technician",
                    "driver",
                    "dispenser_mgr",
                    "d_acct_mgr",
                    "customer_readonly",
                    "customer",
                    "distributor",
                ],
                restrict_by_permission: [],
            },
        },
    ],
};
